import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=5eb0f46b&scoped=true"
import script from "./courseDetails.vue?vue&type=script&lang=js"
export * from "./courseDetails.vue?vue&type=script&lang=js"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=5eb0f46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb0f46b",
  null
  
)

export default component.exports